module.exports = __webpack_public_path__ + "static/media/foursquare.4e27330a.svg";